import { RouteConfig } from 'vue-router'
const Index = () => import('../views/pe-points-system/Index.vue')
const Clazz = () => import('../views/pe-points-system/ClassPointsDetailPage.vue')
const Student = () => import('../views/pe-points-system/StuPointsDetailPage.vue')
const DayExchangeRecordDetailPage = () => import('../views/pe-points-system/DayExchangeRecordDetailPage.vue')
const AllExchangeRecordPage = () => import('../views/pe-points-system/AllExchangeRecordPage.vue')
const OurSchoolExchangeRecordPage = () => import('../views/pe-points-system/OurSchoolExchangeRecordPage.vue')
const AddressConfirmPage = () => import('../views/pe-points-system/PointsGiftAddressConfirmPage.vue')
const IssueRecordPage = () => import('../views/pe-points-system/IssueRecordPage.vue')

const indexRoute: RouteConfig = {
  path: '/pe-points-system',
  name: 'pe_points_system',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体育积分',
    keepAlive: true,
  },
}

const clazzRoute: RouteConfig = {
  path: '/pe-points-system-class',
  name: 'pe_points_system_class',
  component: Clazz,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分情况',
  },
}

const studentRoute: RouteConfig = {
  path: '/pe-points-system-student-detail',
  name: 'pe_points_system_student_detail',
  component: Student,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分明细',
  },
}

const exchangeRecordRoute: RouteConfig = {
  path: '/pe-points-system-day-exchange-record-detail',
  name: 'pe_points_system_day_exchange_record_detail',
  component: DayExchangeRecordDetailPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '兑换明细',
  },
}

const allExchangeRecordRoute: RouteConfig = {
  path: '/pe-points-system-all-exchange-record',
  name: 'pe_points_system_all_exchange_record',
  component: AllExchangeRecordPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '兑换记录',
  },
}

const ourSchoolExchangeRecordRoute: RouteConfig = {
  path: '/pe-points-system-school-exchange-record',
  name: 'pe_points_system_school_exchange_record',
  component: OurSchoolExchangeRecordPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '本校礼品兑换记录',
  },
}

const addressConfirmRoute: RouteConfig = {
  path: '/pe-points-system-gift-address-confirm',
  name: 'pe_points_system_gift_address_confirm',
  component: AddressConfirmPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '领取数字激励盒',
  },
}

const issueRecordRoute: RouteConfig = {
  path: '/pe-points-system-issue-record',
  name: 'pe_points_system_issue_record',
  component: IssueRecordPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业积分发放记录',
  },
}
export default [
  indexRoute,
  clazzRoute,
  studentRoute,
  exchangeRecordRoute,
  addressConfirmRoute,
  issueRecordRoute,
  allExchangeRecordRoute,
  ourSchoolExchangeRecordRoute,
]
